import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const DialogHeader = ({ icon, label }) => {
    return (_jsxs(_Fragment, { children: [_jsx("i", { className: icon, style: { color: 'var(--primary-color)' } }), _jsxs("span", { children: ["\u00A0 ", label] })] }));
};
